<template>
  <el-tooltip class="item" effect="dark" :content="params.node.data.accountTypeName" placement="top">
    <i v-if="params.node.data.accountTypeName" class="el-icon-warning"></i>
  </el-tooltip>
</template>

<script>
export default {
name: "accountTypeCellRenderer"
}
</script>

<style scoped>

</style>
